window.JobApplicationAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);


    self.PREFERRED_LOCATIONS_KEY = 'PREFERRED_LOCATIONS_KEY_';

    self.createDraftApp = function (jobId, isPrivateLink, gRecaptchaResponse) {
        var deferred = $q.defer();

        if (!jobId) {
            console.error("Can't call create draft with job id:", jobId);
            return;
        }

        var trackingSourceData = ReferralUtils.getRefererSource();
        let params = {recaptcha: gRecaptchaResponse};

        if (trackingSourceData.referrer_campaign) {
            params['referrer_campaign'] = trackingSourceData.referrer_campaign;
        }

        if (trackingSourceData.referrer) {
            params['referrer'] = trackingSourceData.referrer;
        }

        if (trackingSourceData.device_type) {
            params['device_type'] = trackingSourceData.device_type;
        }

        if (isPrivateLink) {
            params['referrer'] = 'private';
        }

        _protected.request(`${self.apiUrl.replace('v1', 'v2')}job_apply/create_draft/${jobId}`, 'GET', params).then((data) => {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            }
            else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.deleteApplicationDocumentMedia = async (applicationId, applicationMediaId, placeholderToken) => {
        if (!applicationId) {
            throw 'application id is required';
        }
        if (!applicationMediaId) {
            throw 'applicationMediaId id is required';
        }

        try {
            const params = placeholderToken ? {placeholder_token: placeholderToken} : {};
            const response = await _protected.request(`applications/${applicationId}/application_media/${applicationMediaId}`, 'DELETE', params);
            if (response?.data?.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (err) {
            throw err;
        }
    };

    self.save = function (applicationModel, status, isPrivateLink, isPrivateViaLinkJob) {

        var deferred = $q.defer();
        var params = {
            "job_experience":false,
            "job_cusine":false,
            "job_hecs":false,
            "first_job":false,
            "job_skills":[],
            "job_application_id":applicationModel.id,
            "skill_add_to_profile":false,
            "application_status": status? status: "draft"
        };

        if (applicationModel.talent_scout_code_id) {
            params.talent_scout_code_id = applicationModel.talent_scout_code_id;
        }

        if(applicationModel.job_referrer_id){
            params.job_referrer_id = applicationModel.job_referrer_id;
        }

        if(applicationModel.referrer){
            params.referrer = applicationModel.referrer;
        }

        if(applicationModel.social_media_channel){
            params.social_media_channel = applicationModel.social_media_channel;
        }

        if (applicationModel.applyDisclaimerConsent) {
            params.disclaimer_consent = applicationModel.applyDisclaimerConsent;
        }


        if(applicationModel.user_preferred_locations){
            params.preferred_location_ids = applicationModel.user_preferred_locations;
        }

        if( applicationModel.question_id ){
            params['screen_id'] = applicationModel.question_id;
        }

        if( applicationModel.text_answer ){
            params['job_answer'] = applicationModel.text_answer;
        }

        params = $.extend( params, ReferralUtils.getRefererSource());

        if (isPrivateLink) {
            params['referrer'] = 'private';
        } else if (isPrivateViaLinkJob) {
            params['referrer'] = 'private_via_link';
        }

        _protected.request('job_apply/apply', 'POST', params).then(function (data) {
            _protected.handleResponse(data.data, deferred);
        }, function (err) {
            deferred.reject(err.data);
        });
        return deferred.promise;
    };

    self.deleteApp = async (applicationId, placeholderToken) => {
        try {
            const params = placeholderToken ? {placeholder_token: placeholderToken} : {};
            const data = await _protected.request(`job_apply/cancel_application/${applicationId}`, 'DELETE', params);
            return data;
        } catch (err) {
            throw err;
        }
    };

    self.deleteResume = (applicationId, placeholderToken) => {
        var deferred = $q.defer();

        const params = placeholderToken ? {placeholder_token: placeholderToken} : {};

        _protected.request(`applications/${applicationId}/resume`, 'DELETE', params)
            .then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteApplicationDocuments = (applicationId, placeholderToken) => {
        var deferred = $q.defer();
        var params = {
            type: 'application_document'
        };

        if (placeholderToken) {
            params.placeholder_token = placeholderToken;
        }

        _protected.request('applications/' + applicationId +'/application_media', 'DELETE',params)
            .then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobDetails = function (jobId, privateJobKey) {

        var deferred = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');
        var payload = {};
        if (privateJobKey) {
            payload['pjt'] = privateJobKey;
        }

        _protected.request(apiUrl +'profile/job/' + jobId, 'GET', payload).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200){
                deferred.resolve(data.data.data);
            }
            else {
                deferred.reject(data);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getAppDetails = (appId, placeholderToken) => {

        var deferred = $q.defer();
        let payload = {};
        if (placeholderToken) {
            payload.placeholder_token = placeholderToken;
        }

        _protected.request(self.apiUrl.replace('v1', 'v3') + 'applications/' + appId, 'GET', payload)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                }
                else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAppsDetails = function (appIds) {

        var deferred = $q.defer();

        _protected.request('jobs/applications_form?job_ids=' + appIds, 'GET')
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                }
                else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobsDetails = function (jobsIds, includeATSURL, checkAppliedUser) {

        var deferred = $q.defer();

        var params = {
            ids: jobsIds,
        };

        if (includeATSURL) {
            params.include_ats_url = includeATSURL;
        }

        if (checkAppliedUser) {
            params.check_applied_user = checkAppliedUser;
        }

        _protected.request('/brands/jobs', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.answerScreeningQuestions = function (jobId, appId, formId, questions, formType) {

        var deferred = $q.defer();

        var requestPayload = { questions: questions };

        var newEndpoint = (formType && formType === 'V2')? 'jobs/' + jobId + '/applications/' + appId + '/': '';

        _protected.request(newEndpoint + 'screening_forms/' + formId + '/questions/answers', 'PUT', requestPayload)
            .then(function (res) {
                deferred.resolve(res);
            });

        return deferred.promise;
    };

    self.getTopCandidates = async (brandId, jobId, params) => {
        const response = await _protected.request(`brands/${brandId}/jobs/${jobId}/applications`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.saveAppPreferredLocation = function (applicationId, locationIds) {
        var deferred = $q.defer();

        _protected.request('applications/' + applicationId + '/locations', 'PUT', {
            preferred_locations_ids: locationIds
        })
            .then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.assignAppResume = function (applicationId, userResumeId) {
        var deferred = $q.defer();

        _protected.request('applications/' + applicationId + '/resume/assign', 'PUT', {
            user_resume_id: userResumeId
        })
            .then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAppResumeSignedUrl = function (applicationId, userResumeId, tiny) {
        var deferred = $q.defer();

        tiny = !!tiny;
        var url = 'applications/'+ applicationId + '/resumes/' +userResumeId+ '/signed_url?tiny='+tiny;
        _protected.request(url, 'GET')
            .then(function (data) {
                deferred.resolve(data.data.data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getJobAppOptions = function (brandId, jobId) {
        var deferred = $q.defer();

        var url = 'brands/' + brandId + '/jobs/' + jobId + '/job_application_options';
        _protected.request(url, 'GET')
            .then(function (data) {
                deferred.resolve(data.data.data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getSourcesCategories = function (brandId) {
        var deferred = $q.defer();
        var url = 'brands/' + brandId + '/applications/categories';
        _protected.request(url, 'GET')
            .then(function (data) {
                deferred.resolve(data.data.data.categories);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };
    self.getReferrerList = function (brandId, categoryId) {
        var deferred = $q.defer();
        var url = 'brands/' + brandId + '/applications/categories/' + categoryId + '/sources';
        _protected.request(url, 'GET')
            .then(function (data) {
                deferred.resolve(data.data.data.sources);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAppMediaPresignedUrl = function (appId, applicationDocumentId, fileName) {
        var deferred = $q.defer();

        var url = 'applications/' + appId + '/application_media/presigned_url?type=application_document&application_document_id=' + applicationDocumentId + '&file_name=' + fileName;
        _protected.request(url, 'GET')
            .then(function (data) {
                deferred.resolve(data.data.data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.uploadAppMedia  = function (appId, payload) {
        var deferred = $q.defer();

        _protected.request('applications/' + appId + '/application_media', 'POST', payload)
            .then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveWorkEligibility = function (applicationId, status) {
        var deferred = $q.defer();
        _protected.request('applications/' + applicationId + '/work_eligibility', 'POST', {status: status})
            .then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.submitUserEmail = function (email) {
        var deferred = $q.defer();

        var payload = {
            email: email
        }
        _protected.request('user', 'POST', payload)
            .then(function (data) {
                deferred.resolve(data);
            })
            .catch(function (err) {
                console.error('err', err);
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getJobApplicationDetails = function (brandId, jobId, applicationId) {

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/jobs/' + jobId + '/applications/' + applicationId, 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getResumeUrl = function () {
        var deferred = $q.defer();
        _protected.request('users/resume/presigned_url', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.checkServicesOnJobs = function (jobIds, serviceCodes) {
        var deferred = $q.defer();

        _protected.request('public/jobs/brands/services/check?job_ids=' + jobIds + '&service_codes=' + serviceCodes, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data &&  res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.bulkApply = function (payload) {
        var deferred = $q.defer();

        _protected.request('/jobs/apply', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data &&  res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error('err', err);
                deferred.reject(err);
            });
        return deferred.promise;
    };
});

JobApplicationAPI.APPLICATION_SOURCE_TYPES = {
    JPLP : 'JPLP',
    CAREER_PORTAL: 'CAREER_PORTAL'
};

JobApplicationAPI.UK_WORK_ELIGIBILITY_STATUSES = {
	BRITISH_CITIZEN: {
		CODE: "BRITISH_CITIZEN",
		APP_LABEL: $filter("translate")("I am a British citizen"),
		SPEEDY_LABEL: "British citizen"
	},
	EU_CITIZEN: {
		CODE: "EU_CITIZEN",
		APP_LABEL: $filter("translate")("I am a citizen of the EU, EEA or Switzerland"),
		SPEEDY_LABEL: "Citizen of the EU, EEA or Switzerland"
	},
	VALID_WORK_PERMIT: {
		CODE: "VALID_WORK_PERMIT",
		APP_LABEL: $filter("translate")("I have a valid work permit"),
		SPEEDY_LABEL: "Have a valid work permit"
	},
	NEED_WORK_PERMIT: {
		CODE: "NEED_WORK_PERMIT",
		APP_LABEL: $filter("translate")("I need a work permit"),
		SPEEDY_LABEL: "Need a work permit"
	}
};
